import { auth, User } from '@/plugins/firebase'
import { instanceAuth } from '@/plugins/api'
import router from '@/router'
import { Maybe } from '@/types/maybe'
import { Ref } from 'vue'
import {
  RouteLocationNormalizedLoaded,
  NavigationFailure,
  RouteLocationRaw
} from 'vue-router'

const getCurrentUser = async () => {
  const currentUser = auth.currentUser

  if (!currentUser) return undefined

  try {
    const idToken = await currentUser.getIdToken(true)
    const json = { idToken }
    await instanceAuth.post('sign_in', { json })
    return currentUser
  } catch {
    return null
  }
}

const handleRedirect = async (
  currentUser: Maybe<User>,
  route: Ref<RouteLocationNormalizedLoaded>,
  redirect: (
    to: RouteLocationRaw
  ) => Promise<void | NavigationFailure | undefined>
) => {
  const authRequired = route.value.matched.some(record => record.meta.logged)
  const authUnrequired = route.value.matched.some(record => !record.meta.logged)

  if (authUnrequired && currentUser) {
    const path = route.value.query.redirect?.toString() || ''
    return redirect(path)
  }

  if (authRequired && !currentUser) {
    return redirect({
      name: 'login',
      query: { redirect: route.value.fullPath }
    })
  }

  return false
}

export const getToken = async () => {
  const currentUser = auth.currentUser

  if (!currentUser) return null

  try {
    return await currentUser.getIdToken(true)
  } catch {
    return null
  }
}

auth.onAuthStateChanged(async () => {
  const currentUser = await getCurrentUser()
  handleRedirect(currentUser, router.currentRoute, router.push.bind(router))
})
